module.exports = "/assets/2b28cc1608caa96986b36e4751a72436.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AT.png
// module id = 1207
// module chunks = 0